import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { AuthState } from '../../store/reducers/auth.reducer';
import { AuthDeco, AuthCo } from '../../store/actions/auth.action';
import { selectAuth } from '../../store/selectors/auth.selector';
import { MatButton, MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { AsyncPipe } from '@angular/common';

/**
 * Composant qui donne la possibilité de se connecter ou de se déconnecter et qui affiche l'avatar
 */

@Component({
    selector: 'lib-authentication-form',
    templateUrl: './authentication-form.component.html',
    styleUrls: ['./authentication-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, MatIcon, MatProgressSpinner, MatMiniFabButton, MatMenuTrigger, MatMenu, MatMenuItem, AsyncPipe]
})
export class AuthenticationFormComponent implements OnInit {
  loading$: Observable<boolean>;
  selectAuth$: Observable<AuthState>;

  router = inject(Router);
  route = inject(ActivatedRoute);
  store = inject(Store<AuthState>);
  authService = inject(AuthService);


  ngOnInit() {
      this.selectAuth$ = this.store.pipe(select(selectAuth));
  }

  connectDeconnect() {
    this.selectAuth$.pipe(first()).subscribe((d) => {
      if (d.authentified === true) {
        this.deconnect();
      } else {
        this.connect();
      }
    });
  }

  deconnect() {
    this.route.queryParamMap.pipe(first()).subscribe(
      (paramMap: ParamMap) => this.store.dispatch(new AuthDeco({}))
    );
  }

  connect() {
    this.route.queryParamMap.pipe(first()).subscribe(
      (paramMap: ParamMap) =>
        this.store.dispatch(new AuthCo(paramMap.get('returnUrl') || this.router.url))
    );
  }
}
